import { useCallback } from 'react';

export function useEntityGroups(
  viewerRef: React.MutableRefObject<any>,
  sharedDataSourceRef: React.MutableRefObject<any>,
  entityGroupMap: React.MutableRefObject<Map<string, string[]>>,
  losVisibilityHoldRef: React.MutableRefObject<Map<string, number>>,
) {
  const clearGroup = useCallback((group: string) => {
    const ds = sharedDataSourceRef.current;
    if (!ds) {
      return;
    }
    const v = viewerRef.current;
    if (group === 'los') losVisibilityHoldRef.current.clear();
    const ids = entityGroupMap.current.get(group) ?? [];
    ids.forEach((id) => {
      if (v && v.selectedEntity && (v.selectedEntity.id === id || v.selectedEntity.id === 'selected_sat_point' || v.selectedEntity.id === 'selected_sat_path')) {
        v.selectedEntity = undefined;
      }
      const entity = ds.entities.getById(id);
      if (entity) {
        const removed = ds.entities.remove(entity);
      }
    });
    entityGroupMap.current.set(group, []);
  }, []);

  return {
    clearGroup,
  };
}
